import React from 'react';

import {useCustomerMgr} from 'coreHooks';

import {getPersonalizedItemForCurrentCustomer} from './helpers';
import {IPersonalizedBlockProps, IPersonalizedItemProps} from './IPersonalizedBlock';
import {PersonalizedItem} from './Subcomponents';

const PersonalizedBlock = (props: IPersonalizedBlockProps) => {
	const CustomerMgr = useCustomerMgr();
	const customer = CustomerMgr.getCurrentCustomer();

	const subItemsCollection = props?.personalizedItemsCollection?.items || [];
	const hasSubItemsCollection = subItemsCollection.length > 0;

	// If items are passed as props (already exist)
	if (hasSubItemsCollection) {
		const personalizedItem: IPersonalizedItemProps = getPersonalizedItemForCurrentCustomer(
			subItemsCollection,
			customer,
		);

		if (personalizedItem) {
			if (props.edgeToEdge) {
				return <div><PersonalizedItem personalizedItem={personalizedItem} /></div>;
			} else {
				return <PersonalizedItem personalizedItem={personalizedItem} />;
			}
		}
	}

	// If we have a default item
	return <PersonalizedItem personalizedItem={props.defaultPersonalizedItem} />;
};

export default PersonalizedBlock;
